import { doMutation } from "../../core-module/util/graphqlHelper";

export const createOrUpdateOrganization = organization => {
  const mutation = require("../api/mutation/createOrUpdateOrganization.gql");
  const variables = { input: organization };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.createOrUpdateOrganization };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
